var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageappointmentDis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7728 0.842773C2.03425 0.842773 1.43555 1.44148 1.43555 2.18002V13.8164C1.43555 14.8959 2.64869 15.5305 3.53545 14.9148L7.75043 11.9884C7.90038 11.8843 8.09923 11.8843 8.24917 11.9884L12.4642 14.9148C13.3509 15.5305 14.5641 14.8959 14.5641 13.8164V2.18002C14.5641 1.44148 13.9654 0.842773 13.2268 0.842773H2.7728ZM13.5753 2.18002V3.11402H2.42427V2.18002C2.42427 1.98754 2.58031 1.8315 2.7728 1.8315H13.2268C13.4193 1.8315 13.5753 1.98754 13.5753 2.18002ZM2.42427 4.10274H13.5753V13.8164C13.5753 14.0977 13.2592 14.2631 13.028 14.1027L8.81305 11.1762C8.32404 10.8367 7.67557 10.8367 7.18656 11.1762L2.97157 14.1027C2.74045 14.2631 2.42427 14.0977 2.42427 13.8164V4.10274Z",
    fill: "grey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageappointmentDis);
export default __webpack_public_path__ + "static/media/Manage appointment_dis.57dc46f82d4620f0d461f689545f6eba.svg";
export { ForwardRef as ReactComponent };